import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BasketEntry, LinkRef, Price } from '@kion/data-models';
import { ProductPriceService } from '../../../services/product-price.service';
import { FormBuilder, FormGroup } from '@angular/forms';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { ProductUrlService } from '../../../../../../cms/src/lib/services/product-url.service';

@Component({
  selector: 'kion-basket-list-item',
  templateUrl: './basket-list-item.component.html',
  styleUrls: ['./basket-list-item.component.scss']
})
export class BasketListItemComponent {

  @Input() entry: BasketEntry;
  @Input() editable: boolean;
  @Output('quantityChanged') quantityChangedEmitter: EventEmitter<{entryNumber: number, quantity: number}> = new EventEmitter<{entryNumber: number, quantity: number}>();
  @Output('delete') deleteEntryEmitter: EventEmitter<number> = new EventEmitter<number>();

  form: FormGroup;

  constructor(
    private priceService: ProductPriceService,
    private productUrlService: ProductUrlService,
    formBuilder: FormBuilder
  ) {
    this.form = formBuilder.group({});
  }

  getNettoPrice(price: Price): string {
    return this.priceService.getNettoPrice(price);
  }

  getNettoStrikedPrice(price: Price): string {
    return this.priceService.getStrikedNettoPrice(price);
  }

  get isContract(): boolean {
    if (this.entry?.productOptions){
      return !!this.entry.productOptions.find(
        option => option.code === 'CONTRACT'
      )
    }
    return false;
  }

  get productLink(): LinkRef {
    return this.productUrlService.generateUrlFromProduct(this.entry.product);
  }

  quantityChanged(quantity: number) {
    this.quantityChangedEmitter.emit({entryNumber: this.entry.entryNumber, quantity: quantity});
  }

  delete() {
    this.deleteEntryEmitter.emit(this.entry.entryNumber);
  }
}
